// @flow

import { type OutgoingPayment } from '../outgoing-payment';

export async function externalChileOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: 'webpay-rest',
  };
}
